
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.5397 20.3311L8.90393 44.9668","stroke":"#EE7F1A","stroke-width":"3.28477","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.8311 40.0397C3.9768 23.6159 17.1159 7.19206 45.0364 8.83444C46.6788 36.755 30.2549 49.894 13.8311 40.0397Z","stroke":"#EE7F1A","stroke-width":"3.28477","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    